import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Divider from '../../Shared/UI/Divider/components/Divider';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import NewUnrecognizedSkillFormForModal from './NewUnrecognizedSkillFormForModal';
import CircleLoader from '../../Shared/UI/CircleLoader/components/CircleLoader';
import SkillsModalTable from './SkillsModalTable';
import SkillsModalPageController from './SkillsModalPageController';

import { useProfileState, useProfileActions } from './ProfileContext';

const SkillsModal = () => {
  const profileState = useProfileState();
  const { closeUserSkillsModal } = useProfileActions();

  const hasSkillsFromApi = profileState.skillsModal?.skills?.length > 0;

  const mainModalContent = profileState.skillsModal.loading ? (
    <CircleLoader />
  ) : (
    <>
      <SkillsModalTable />
      {hasSkillsFromApi && <SkillsModalPageController />}
    </>
  );

  return (
    <StandardModal
      isOpen={profileState.userSkillsModalIsOpen}
      contentLabel={'Update Your Skills'}
      onRequestClose={() => {
        closeUserSkillsModal();
      }}
    >
      <PageTitle text={'Skills'} />
      <NewUnrecognizedSkillFormForModal />
      <Divider />
      {mainModalContent}
    </StandardModal>
  );
};

export default SkillsModal;
